import React from 'react';
import {TugValor, BillOfRights, Anchor} from './icons';

const VesselIcon = ({vesselType, ...props}) => {
    switch (vesselType) {
        case 'Motor Vessel':
            return <TugValor {...props} />;

        case 'Sailing Vessel':
            return <BillOfRights {...props} />;

        case 'Towing Vessel':
            return <TugValor {...props} />;

        case 'High Speed Craft':
            return <Anchor {...props} />;

        default:
            return <Anchor {...props} />;
    }
};

export default VesselIcon;
